/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';
import { ToolService } from 'app/common/services';
import { type Observable } from 'rxjs';

import { InfigoService } from '../../../infigo.service';
import { SourceEnumService } from '../../../source-enum.service';
import { RefreshComponent } from '../../RefreshComponent';

@Component({
    selector: 'app-tenant-base-info',
    templateUrl: './tenant-base-info.component.html',
})
export class TenantBaseInfoComponent extends RefreshComponent {
    @Input() item;
    loading = true;
    detail: any = {};
    baseInfo;
    capacityPercentData = 0;

    constructor(
        public infigoService: InfigoService,
        public i18n: I18nService,
        public enumService: SourceEnumService,
        public changeDetectorRef: ChangeDetectorRef,
        public toolService: ToolService,
    ) {
        super();
        const I18N = i18n.get;
        const enumGet = enumService.get.bind(enumService, 'TENANT');
        const supportSmartThin = this.toolService.supportSmartThinLicense();
        this.baseInfo = [
            {
                title: I18N('common.runningStatus_column'),
                key: 'RUNNINGSTATUS',
                enumMap: enumGet('RUNNINGSTATUS'),
            },
            ...(supportSmartThin ? [{
                title: I18N('service.vstore_task_view_LUNNum_column'),
                key: 'lunCount',
            }, {
                title: I18N('service.vstore_task_view_totalLUNCap_lab'),
                key: 'lunTotalCapacity',
                templateName: 'Capacity',
            }] : []),
            {
                title: I18N('service.vstore_task_view_fsNum_column'),
                key: 'fileSystemCount',
            }, {
                title: I18N('service.vstore_task_view_totalFSCap_lab'),
                key: 'fileSystemCapacity',
                templateName: 'Capacity',
            },
        ];
    }

    requestInfo(): Observable<any> {
        return this.infigoService.getVstore(this.item.actionParams);
    }

    handleRequest(value: any): void {
        this.detail = value.data;
        this.loading = false;
        this.capacityPercentData = this.infigoService.usageValue(this.detail);
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }
}
